function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import * as monaco from 'monaco-editor';
import classNames from 'classnames';
import "./InputEditor.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A monaco editor that looks like an general input
 */

export class InputEditor extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "editorContainer", void 0);
    _defineProperty(this, "editor", void 0);
    this.handleContentChanged = this.handleContentChanged.bind(this);
    this.handleEditorFocus = this.handleEditorFocus.bind(this);
    this.handleEditorBlur = this.handleEditorBlur.bind(this);
    this.handleContainerClick = this.handleContainerClick.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.state = {
      isEditorFocused: false,
      isEditorEmpty: true
    };
    this.editorContainer = null;
  }
  componentDidMount() {
    this.initEditor();
  }
  componentWillUnmount() {
    this.destroyEditor();
  }
  initEditor() {
    var _this$editor$getModel;
    var _this$props = this.props,
      value = _this$props.value,
      editorSettings = _this$props.editorSettings;
    var inputEditorSettings = _objectSpread({
      copyWithSyntaxHighlighting: 'false',
      fixedOverflowWidgets: true,
      folding: false,
      fontFamily: 'Fira Mono',
      glyphMargin: false,
      language: 'groovyDB',
      lineDecorationsWidth: 8,
      lineNumbers: 'off',
      minimap: {
        enabled: false
      },
      renderLineHighlight: 'none',
      scrollbar: {
        arrowSize: 0,
        horizontal: 'hidden',
        horizontalScrollbarSize: 0
      },
      scrollBeyondLastLine: false,
      padding: {
        top: 6,
        bottom: 6
      },
      tabCompletion: 'off',
      useTabStops: true,
      value,
      wordWrap: 'on',
      automaticLayout: true,
      autoClosingBrackets: 'beforeWhitespace'
    }, editorSettings);
    if (!this.editorContainer) {
      throw new Error('editorContainer is null');
    }
    this.editor = monaco.editor.create(this.editorContainer, inputEditorSettings);
    this.editor.layout();

    // disable tab to spaces in this editor to improve tab navigation
    (_this$editor$getModel = this.editor.getModel()) === null || _this$editor$getModel === void 0 || _this$editor$getModel.updateOptions({
      tabSize: 0
    });

    // monaco does not propagate tab or enter events
    this.editor.onKeyDown(this.handleKeyDown);
    this.editor.onDidChangeModelContent(this.handleContentChanged);
    this.editor.onDidFocusEditorText(this.handleEditorFocus);
    this.editor.onDidBlurEditorText(this.handleEditorBlur);
  }
  destroyEditor() {
    var _this$editor;
    (_this$editor = this.editor) === null || _this$editor === void 0 || _this$editor.dispose();
    this.editor = undefined;
  }
  handleContentChanged() {
    var _this$editor2;
    var onContentChanged = this.props.onContentChanged;
    var value = (_this$editor2 = this.editor) === null || _this$editor2 === void 0 || (_this$editor2 = _this$editor2.getModel()) === null || _this$editor2 === void 0 ? void 0 : _this$editor2.getValue();
    if (value !== undefined) {
      this.setState({
        isEditorEmpty: value.length === 0
      });
    }
    onContentChanged(value);
  }
  handleEditorFocus() {
    this.setState({
      isEditorFocused: true
    });
  }
  handleEditorBlur() {
    var _this$editor$getModel2, _this$editor3;
    var value = (_this$editor$getModel2 = (_this$editor3 = this.editor) === null || _this$editor3 === void 0 || (_this$editor3 = _this$editor3.getModel()) === null || _this$editor3 === void 0 ? void 0 : _this$editor3.getValue()) !== null && _this$editor$getModel2 !== void 0 ? _this$editor$getModel2 : '';
    this.setState({
      isEditorEmpty: value.length === 0,
      isEditorFocused: false
    });
  }

  // force editor to focus if clicked
  handleContainerClick() {
    var _this$editor4;
    var isEditorFocused = this.state.isEditorFocused;
    if (isEditorFocused) {
      return;
    }
    (_this$editor4 = this.editor) === null || _this$editor4 === void 0 || _this$editor4.focus();
  }
  handleKeyDown(event) {
    var _this$props2 = this.props,
      onTab = _this$props2.onTab,
      editorIndex = _this$props2.editorIndex;
    if (event.code === 'Tab') {
      event.stopPropagation();
      event.preventDefault();
      onTab(editorIndex, event.shiftKey);
    }
  }
  render() {
    var _this$props3 = this.props,
      className = _this$props3.className,
      invalid = _this$props3.invalid,
      _this$props3$placehol = _this$props3.placeholder,
      placeholder = _this$props3$placehol === void 0 ? '' : _this$props3$placehol,
      value = _this$props3.value;
    var _this$state = this.state,
      isEditorFocused = _this$state.isEditorFocused,
      isEditorEmpty = _this$state.isEditorEmpty;
    return /*#__PURE__*/_jsxs("div", {
      className: classNames('input-editor-wrapper', {
        focused: isEditorFocused,
        invalid
      }, className),
      role: "presentation",
      onClick: this.handleContainerClick,
      children: [/*#__PURE__*/_jsx("div", {
        className: "editor-container",
        ref: editorContainer => {
          this.editorContainer = editorContainer;
        },
        "data-testid": "custom-column-formula"
      }), isEditorEmpty && !value && placeholder.length > 0 && /*#__PURE__*/_jsx("div", {
        className: "editor-placeholder text-muted",
        children: placeholder
      })]
    });
  }
}
_defineProperty(InputEditor, "defaultProps", {
  value: '',
  onContentChanged: () => undefined,
  editorSettings: {},
  editorIndex: 0,
  onTab: () => undefined,
  invalid: false
});
export default InputEditor;
//# sourceMappingURL=InputEditor.js.map